// extracted by mini-css-extract-plugin
module.exports = {"container":"loaderB_container__3aRSa"};